var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"payment-required-banner"}},[_c('a',{attrs:{"href":"team/?tab=4"}},[_c('div',{staticClass:"payment-required-text"},[_vm._v(" "+_vm._s(_vm.$t('paymentRequiredBanner.text', { date: _vm.formattedValidUntil }))+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }